"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var focus_trap_react_1 = __importDefault(require("focus-trap-react"));
var S = __importStar(require("./LftBackdrop.styles"));
var LftBackdrop = function (_a) {
    var children = _a.children, clickOutside = _a.clickOutside, dataTestId = _a.dataTestId, visible = _a.visible, lftClick = _a.lftClick;
    (0, react_1.useEffect)(function () {
        if (visible && typeof window !== 'undefined') {
            document.body.style.overflow = 'hidden';
            return function () {
                document.body.style.overflow = 'unset';
            };
        }
        return;
    }, [visible]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(focus_trap_react_1.default, __assign({ active: visible, focusTrapOptions: {
                    tabbableOptions: {
                        displayCheck: 'none',
                    },
                    allowOutsideClick: clickOutside,
                    escapeDeactivates: false,
                    initialFocus: false
                } }, { children: children })), (0, jsx_runtime_1.jsx)(S.Backdrop, { "data-testid": dataTestId, onClick: lftClick, visible: visible, "data-lift": "lft-backdrop" })] }));
};
exports.default = LftBackdrop;
